
import React, {useState, useEffect, useRef} from 'react';
import reactDom from 'react-dom';
import axios from 'axios';

function OrderForm(props)
{
    const formRef = useRef(null);

    const [host, setHost] = useState('');
    const [isProcess, setIsProcess] = useState(false);

    const [items, setItems] = useState([]);

    const [errors, setErrors] = useState({
        firstname: '',
        lastname: '',
        email: '',
        works_with: '',
        item: '',
        quantity: '',
        captcha: ''
    });

    const [captcha, setCaptcha] = useState({
        img: '',
        key: ''
    })

    const [message, setMessage] = useState('');

    useEffect(() => {
        let h = document.querySelector('meta[name="host"]').content;
        setHost(h);
        refreshCaptcha();
    }, [])

    const refreshCaptcha = () => {
        axios.get(host+'/captcha/api/mini')
        .then(res => {
            setCaptcha(res.data)
        })
    }

    const handleSubmit = e => {
        e.preventDefault();

        setIsProcess(true);

        setErrors({
            firstname: '',
            lastname: '',
            email: '',
            works_with: '',
            item: '',
            quantity: '',
            captcha: ''
        });

        setMessage('');

        let data = new FormData(e.target)

        axios.post(host+'/order', data)
        .then(res => {
            setIsProcess(false);
            refreshCaptcha();
            if (res.data.message) {
                setMessage(res.data.message);
                formRef.current.reset();
                setTimeout(() => {
                    location.href = host+'/thankyou';
                }, 800);
            }
        })
        .catch(err => {
            setIsProcess(false);
            refreshCaptcha();
            if (err.response.data.errors)
            {
                setErrors(err.response.data.errors)
            }
        })
    }

    const handleWorksChange = e => {
        e.preventDefault();

        switch (e.target.value)
        {
            case 'Brand Identity Design':
                setItems(JSON.parse(props.serviceBid));
                break;
            case 'Digital Media Design':
                setItems(JSON.parse(props.serviceDmd));
                break;
            case 'Print Design':
                setItems(JSON.parse(props.servicePd));
                break;
            default:
                setItems([]);
                break;
        }
    }

    return (
        <form onSubmit={handleSubmit} ref={formRef}>

            {/* Firstname and Lastname */}
            <div className="row g-3">
                <div className="col-lg-6 col-12">
                    <div className="mb-3 form-floating">
                        <input type="text" className="form-control" name="firstname" id="firstname" placeholder="first name"/>
                        <label htmlFor="firstname" className="cl-orange">First Name</label>
                        <small className="text-light">{errors.firstname}</small>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="mb-3 form-floating">
                        <input type="text" className="form-control" name="lastname" id="lastname" placeholder="last name"/>
                        <label htmlFor="lastname" className="cl-orange">Last Name</label>
                        <small className="text-light">{errors.lastname}</small>
                    </div>
                </div>
            </div>

            {/* Email */}
            <div className="mb-3 form-floating">
                <input className="form-control" type="email"  name="email" placeholder="Email"/>
                <label htmlFor="email" className="cl-orange">Email*</label>
                <small className="text-light">{errors.email}</small>
            </div>

            {/* Works with */}
            <div className="form-floating mb-3">
                <select className="form-select" name="works_with" id="floatingSelectGrid" aria-label="Works with select" onChange={handleWorksChange}>
                    <option value=''>Choose</option>
                    <option value="Brand Identity Design">Brand Identity Design</option>
                    <option value="Digital Media Design">Digital Media Design</option>
                    <option value="Print Design">Print Design</option>
                </select>
                <label htmlFor="floatingSelectGrid" className="cl-orange">Works with select</label>
                <small className="text-light">{errors.works_with}</small>
            </div>

            {/* Items and Quantity */}
            <div className="row mb-3">
                <div className="col-lg-8 col-12">
                    <div className="form-floating mb-3">
                        <select className="form-select" name="item" id="inputItem" aria-label="Items selects">
                            <option value="">Choose</option>
                            {items.map((v, i) => {
                                return (
                                    <option value={v} key={i}>{v.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</option>
                                )
                            })}
                        </select>
                        <label htmlFor="inputItem" className="cl-orange">Items select</label>
                    </div>
                </div>
                <div className="col-12 col-lg-4">
                    <div className="mb-3 form-floating">
                        <input type="text" className="form-control" name="quantity" id="qty" defaultValue={1}/>
                        <label htmlFor="qty" className="cl-orange">Qty</label>
                    </div>
                </div>
                <div className="col-12">
                    <small className="text-light">{errors.item}</small>
                    <small className="text-light">{errors.quantity}</small>
                </div>
            </div>

            {/* Captcha */}
            <div className="mb-3">
                <div className="row row-cols-1 g-2">
                    <div className="col">
                        <img src={captcha.img} id="captcha" alt="captcha" height="50"/>
                        <button type="button" onClick={refreshCaptcha} className="btn btn-order ms-2">Refresh Captcha</button>
                    </div>
                    <div className="col">
                        <input type="hidden" name="key" value={captcha.key} />
                        <div className="form-floating">
                            <input className="form-control" type="text" id="captcha" name="captcha" placeholder="Captcha"/>
                            <label htmlFor="captcha" className="cl-orange">Captcha</label>
                            <small className="text-light">{errors.captcha}</small>
                        </div>
                    </div>
                </div>
            </div>

            {/* Status Message */}
            <div className="form-group mb-4">
                <small className="text-light">{message}</small>
            </div>

            <p>{props.description}</p>
            {/* Submit Button */}
            <div className="form-group">
                <button type="submit" className={`btn btn-order mt-3 ${isProcess ? 'disabled' : ''}`} disabled={isProcess}>
                    {isProcess && 'Processing ...'}
                    {!isProcess && 'Submit'}
                </button>
            </div>
        </form>
    )
}

const container = document.querySelector('#orderForm');
reactDom.render(<OrderForm {...(container.dataset)} />, container);
